require('./bootstrap');

// const turbolinks = require('turbolinks');
// document.addEventListener('livewire:load', () => turbolinks.start());
